import { render } from "./ProjectsWidgets.vue?vue&type=template&id=1ad6b3cc&scoped=true"
import script from "./ProjectsWidgets.vue?vue&type=script&lang=js"
export * from "./ProjectsWidgets.vue?vue&type=script&lang=js"

import "./ProjectsWidgets.vue?vue&type=style&index=0&id=1ad6b3cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ad6b3cc"

export default script